import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onBulkStatusUpdate, onBulkPermissionChange, onBulkDelete, onClearSelection }) => {
  const [showActions, setShowActions] = useState(false);

  if (selectedCount === 0) return null;

  const handleBulkAction = (action, value = null) => {
    switch (action) {
      case 'activate': onBulkStatusUpdate('active');
        break;
      case 'deactivate': onBulkStatusUpdate('inactive');
        break;
      case 'suspend': onBulkStatusUpdate('suspended');
        break;
      case 'delete':
        onBulkDelete();
        break;
      case 'permissions':
        onBulkPermissionChange(value);
        break;
      default:
        break;
    }
    setShowActions(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-1100">
      <div className="bg-card border border-border rounded-lg shadow-modal p-4 min-w-[320px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <Icon name="Users" size={16} color="white" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">
                {selectedCount} employee{selectedCount > 1 ? 's' : ''} selected
              </p>
              <p className="text-xs text-muted-foreground">Choose an action to apply</p>
            </div>
          </div>
          
          <Button
            variant="ghost"
            size="icon"
            onClick={onClearSelection}
            className="h-8 w-8"
          >
            <Icon name="X" size={16} />
          </Button>
        </div>

        <div className="flex items-center space-x-2 mt-4">
          {/* Status Actions */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowActions(!showActions)}
              iconName="Settings"
              iconPosition="left"
              iconSize={14}
            >
              Status
              <Icon name="ChevronDown" size={14} className="ml-1" />
            </Button>
            
            {showActions && (
              <div className="absolute bottom-full left-0 mb-2 w-48 bg-popover border border-border rounded-md shadow-modal z-1200">
                <div className="py-1">
                  <button
                    onClick={() => handleBulkAction('activate')}
                    className="w-full px-3 py-2 text-left text-sm text-popover-foreground hover:bg-muted flex items-center space-x-2"
                  >
                    <Icon name="CheckCircle" size={14} className="text-success" />
                    <span>Activate Selected</span>
                  </button>
                  <button
                    onClick={() => handleBulkAction('deactivate')}
                    className="w-full px-3 py-2 text-left text-sm text-popover-foreground hover:bg-muted flex items-center space-x-2"
                  >
                    <Icon name="Pause" size={14} className="text-warning" />
                    <span>Deactivate Selected</span>
                  </button>
                  <button
                    onClick={() => handleBulkAction('suspend')}
                    className="w-full px-3 py-2 text-left text-sm text-popover-foreground hover:bg-muted flex items-center space-x-2"
                  >
                    <Icon name="Ban" size={14} className="text-destructive" />
                    <span>Suspend Selected</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Permission Actions */}
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction('permissions', 'billing')}
            iconName="Shield"
            iconPosition="left"
            iconSize={14}
          >
            Permissions
          </Button>

          {/* Export Action */}
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            iconSize={14}
          >
            Export
          </Button>

          {/* Delete Action */}
          <Button
            variant="destructive"
            size="sm"
            onClick={() => handleBulkAction('delete')}
            iconName="Trash2"
            iconPosition="left"
            iconSize={14}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;